module.exports = __webpack_public_path__ + "static/media/outfit8.0e4196fb.jpg";